"use client";

import {
  Text,
  TextColor,
  TextSize,
  TextWeight,
} from "@workspace/ui/components";
import Link from "next/link";
import { useState } from "react";

interface ContentSidebarProps {
  activePage?: string;
}

const ContentSidebar = ({ activePage }: ContentSidebarProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    {
      title: "Sklep internetowy",
      isHeader: true,
    },
    {
      title: "Tabela rozmiarów",
      href: "/tabela-rozmiarow",
      slug: "tabela-rozmiarow",
    },
    {
      title: "Reklamacje i zwroty",
      href: "/reklamacje-i-zwroty",
      slug: "reklamacje-i-zwroty",
    },
    {
      title: "FAQ",
      href: "/faq-online",
      slug: "faq-online",
    },
    {
      title: "Regulamin sklepu",
      href: "/regulamin-sklepu",
      slug: "regulamin-sklepu",
    },
    {
      title: "Polityka prywatności",
      href: "/polityka-prywatnosci",
      slug: "polityka-prywatnosci",
    },
    {
      title: "Dostawa i płatność",
      href: "/dostawa-i-platnosc",
      slug: "dostawa-i-platnosc",
    },
    {
      title: "Zmiana operatora",
      href: "/zmiana-operatora-i-administratora-sklepu",
      slug: "zmiana-operatora-i-administratora-sklepu",
    },
    {
      title: "Sklepy stacjonarne",
      isHeader: true,
    },
    {
      title: "Lista salonów Carry",
      href: "/lista-salonow-carry",
      slug: "lista-salonow-carry",
    },
    {
      title: "FAQ",
      href: "/faq-stacjonarne",
      slug: "faq-stacjonarne",
    },
  ];

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="bg-white border border-gray-200 border-b-0">
      {/* Przycisk toggle dla mobile */}
      <div className="lg:hidden">
        <button
          onClick={toggleSidebar}
          className="w-full px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
        >
          <Text
            text="Menu"
            weight={TextWeight.BOLD}
            fontSize={TextSize.M}
            color={TextColor.BLACK}
          />
          <svg
            className={`w-5 h-5 transition-transform duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>
      </div>

      {/* Nawigacja z płynną animacją */}
      <div
        className={`
          overflow-hidden transition-all duration-300 ease-in-out
          ${isOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"}
          lg:max-h-none lg:opacity-100
        `}
      >
        <nav>
          {menuItems.map((item, index) => {
            if (item.isHeader) {
              return (
                <div
                  key={index}
                  className="px-6 py-4 border-b border-gray-200 text-center"
                >
                  <Text
                    text={item.title}
                    weight={TextWeight.BOLD}
                    fontSize={TextSize.M}
                    color={TextColor.BLACK}
                  />
                </div>
              );
            }

            const isActive = activePage === item.slug;

            return (
              <div key={index} className="border-b border-gray-200">
                <Link
                  href={item.href!}
                  className={`
                    block px-6 py-4 transition-colors duration-200
                    ${
                      isActive
                        ? "bg-gray-50 border-l-4 border-black text-black font-medium"
                        : "text-gray-700 hover:text-gray-900 hover:bg-gray-50"
                    }
                  `}
                  onClick={() => setIsOpen(false)}
                >
                  <Text
                    text={item.title}
                    color={TextColor.BLACK}
                    fontSize={TextSize.XS}
                  />
                </Link>
              </div>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default ContentSidebar;
